module.exports = __webpack_public_path__ + "media/images/svg-icon/error-fdd587fd4bab67976b056b9031398505.svg";